//ParkUserCreateActions.js
import axios from "axios";
import toast from "react-hot-toast";

/* =====================================================
   CONSTANTS
===================================================== */

// Get Park Details
export const FETCH_PARK_DETAILS_REQUEST = "FETCH_PARK_DETAILS_REQUEST";
export const FETCH_PARK_DETAILS_SUCCESS = "FETCH_PARK_DETAILS_SUCCESS";
export const FETCH_PARK_DETAILS_FAILURE = "FETCH_PARK_DETAILS_FAILURE";

// Create Park User
export const CREATE_PARK_USER_REQUEST = "CREATE_PARK_USER_REQUEST";
export const CREATE_PARK_USER_SUCCESS = "CREATE_PARK_USER_SUCCESS";
export const CREATE_PARK_USER_FAILURE = "CREATE_PARK_USER_FAILURE";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

/* =====================================================
   COMMON AXIOS INSTANCE
===================================================== */

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      authorization: token,
      "Content-Type": "application/json",
    },
  };
};

/* =====================================================
   1️⃣ GET PARK DETAILS BY LOCATION
===================================================== */

export const fetchParkDetailsByLocation = ({
  district_id,
  municipality_id,
  project_type = "",
} = {}) => {
  return async (dispatch) => {

    dispatch({ type: FETCH_PARK_DETAILS_REQUEST });

    try {

      const params = {};

      if (district_id) params.district_id = district_id;
      if (municipality_id) params.municipality_id = municipality_id;
      if (project_type) params.project_type = project_type;

      const queryParams = new URLSearchParams(params).toString();

      const response = await axios.get(
        `${BASE_URL}/v1/api/admin/park_details_by_location?${queryParams}`,
        getAuthHeaders()
      );

      dispatch({
        type: FETCH_PARK_DETAILS_SUCCESS,
        payload: response.data.data || [],
      });

    } catch (error) {

      const message =
        error?.response?.data?.meta?.message ||
        "Failed to fetch park details";

      dispatch({
        type: FETCH_PARK_DETAILS_FAILURE,
        payload: message,
      });

      toast.error(message);
    }
  };
};

/* =====================================================
   2️⃣ CREATE PARK USER
===================================================== */

export const createParkUser = (userData) => {
  return async (dispatch) => {

    dispatch({ type: CREATE_PARK_USER_REQUEST });

    try {

      const response = await axios.post(
        `${BASE_URL}/v1/api/admin/create_park_user`,
        userData,
        getAuthHeaders()
      );

      dispatch({
        type: CREATE_PARK_USER_SUCCESS,
        payload: response.data.data,
      });

      // toast.success("Park user created successfully");

    } catch (error) {

      const message =
        error?.response?.data?.meta?.message ||
        "Failed to create park user";

      dispatch({
        type: CREATE_PARK_USER_FAILURE,
        payload: message,
      });

      toast.error(message);
    }
  };
};